import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AuthenticationService } from '../_services/authentication.service';
import { LoginRequest } from '../_model/login.request';
import { LoginResponse } from '../_model/response/login.response';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../_services/data.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule
  ]
})
export class LoginComponent implements OnInit {
  hidePassword = true;
  returnUrl: string;
  loginForm = this.formBuilder.group({
    userName: ['', [Validators.maxLength(100), Validators.required]],
    password: ['', [Validators.required]]
  });
  loginRequest: LoginRequest;
  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    public router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private toastr: ToastrService) { }

  ngOnInit() {

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.authService.currentUserValue) {
      this.router.navigate(['']);
    }
  }

  private checkAppVersion(serverVersion: string): boolean {
    // Eğer client version tanımlı değilse (eski sürümler)
    console.log(environment.clientVersion);
    if (!environment.clientVersion) {
      // Eski sürüm olduğu için güncelleme gerekli
      return true;
    }

    // Normal versiyon kontrolü
    return serverVersion !== environment.clientVersion;
  }

  onSubmit() {
    this.loginRequest = {
        userName: this.loginForm.get('userName')?.value ?? '',
        password: this.loginForm.get('password')?.value ?? ''
      } as LoginRequest;
    this.authService.login(this.loginRequest).subscribe({
      next: (response) => {
        const loginResponse: LoginResponse = response.responseData.item;

        if(loginResponse.version == null)
          this.handleSuccessfulLogin(loginResponse);
        // Versiyon kontrolü
        if (this.checkAppVersion(loginResponse.version) || !loginResponse.version) {
          this.toastr.info('Uygulama güncelleniyor...', 'Güncelleme');
          this.forceRefresh();
        }
        else {
          this.handleSuccessfulLogin(loginResponse);
        }
      },
      error: (error) => {
        this.toastr.error(error.error.msg, 'Hata');
      }
    });
  }

  private handleSuccessfulLogin(loginResponse: LoginResponse): void {
    loginResponse.selectedRole = loginResponse.role[0];
    localStorage.setItem('currentUser', JSON.stringify(loginResponse));
    this.authService.assignCurrentUser(loginResponse);
    this.router.navigateByUrl(this.returnUrl);
  }

  private forceRefresh(): void {
    document.location.reload();
  }

}
